import React from 'react';
import styled from 'styled-components';
import { Formik, Form } from 'formik';
import * as Yup from 'yup';
import { H2, ButtonPrimary, Input } from '@yuhu-inc/yuhui';

import { Loading } from 'components/ui/LoadingIndicator';
import { getTranslatedString } from 'helpers/i18n';

const StyledForm = styled(Form)`
  width: 100%;
  position: relative;
`;

const StyledInput = styled(Input)`
  max-width: 40rem;
  margin: 5rem 0;
`;

const StyledInner = styled.div`
  width: 100%;
  overflow-y: hidden;
  display: flex;
  flex-direction: column;
  align-items: center;
  visibility: ${(props) => (props.shouldRender ? 'visible' : 'hidden')};
`;

const TemplateNameSchema = Yup.object().shape({
  name: Yup.string().required(),
});

export const AddTemplateNamePage = ({ handleCreateTemplate, upsertingTemplate, closeDialog }) => {
  return (
    <Formik
      initialValues={{
        name: undefined,
      }}
      validationSchema={TemplateNameSchema}
      onSubmit={async (values) => {
        if (values.name) {
          await handleCreateTemplate(values);
          closeDialog();
        }
      }}
    >
      {({ values, setFieldValue }) => (
        <StyledForm name="inspection_template_name">
          <Loading
            shouldRender={upsertingTemplate}
            isFullscreen={true}
            text={getTranslatedString('landlordPortal.inspections.loadingText')}
          />
          <StyledInner shouldRender={!upsertingTemplate}>
            <H2 contentKey="landlordPortal.inspections.nameYourTemplate" centered />
            <StyledInput
              value={values.name}
              onChange={(e) => setFieldValue('name', e.target.value)}
              name="name"
              type="text"
              required
              contentKey="landlordPortal.inspections.templateName"
            />
            <ButtonPrimary disabled={!values.name} contentKey="landlordPortal.inspections.next" />
          </StyledInner>
        </StyledForm>
      )}
    </Formik>
  );
};
